/**
 * @param {Yup.objectSchema<Object>} schema - yup shape
 * @param {Object} data
 * @returns {{ status: boolean, data?: Object, errors?: Object}}
 */
import { ERRORS } from '@/services/Validator/errors'
import { Schema } from 'yup'

export function validateAll(schema: Schema, data: any) {
  const result = {
    status: true,
    data: data,
    errors: {},
  }

  try {
    schema.validateSync(data, { abortEarly: false })
  } catch (errors) {
    result.status = false
    result.errors = errors.inner.reduce((acc, e) => {
      const key = e.path.length === 0 ? 'unknown' : e.path
      if (!acc[key]) {
        acc[key] = e.message
      }
      return acc
    }, {})
  }

  return result
}

export function validateAt(schema: Schema, path: string, value: any) {
  const result = {
    status: true,
    error: undefined,
  }
  try {
    schema.validateSyncAt(path, { [path]: value })
  } catch (error) {
    result.status = false
    result.error = error.message
  }

  return result
}

export function prepareApiErrors(error: { [key: string]: string | string[] }) {
  return Object.entries(error).reduce((acc, [key, value]) => {
    acc[key] = Array.isArray(value)
      ? ERRORS[value[0]] ?? value[0]
      : ERRORS[value] ?? value
    return acc
  }, {})
}
